import { createSurveyStyles } from '@sm/webassets';
import { Theme } from '@wds/styles';
import { evaluateTextColorVisibility, getThemeColors } from '~app/pages/EnterpriseThankYou/helpers/themeColors';

type StyleNames = 'bodyTextStyles' | 'contentPadding' | 'image';
type StyleProps = { isRedirect: boolean; wrenchTheme: Theme };

const useStyles = createSurveyStyles<StyleNames, StyleProps>(theme => {
  const { headerTextColor, bodyTextColor, backgroundColor } = getThemeColors(theme);
  const visibleColor = evaluateTextColorVisibility(bodyTextColor, headerTextColor, backgroundColor);
  return {
    bodyTextStyles: ({ wrenchTheme }) => ({
      color: visibleColor,
      fontFamily: wrenchTheme.type.fontFamily.base,
      fontWeight: wrenchTheme.type.fontWeight.regular,
      fontSize: wrenchTheme.type.fontSize.body,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'center',
      '& a': {
        color: 'inherit',
        textDecoration: 'underline',
      },
    }),
    contentPadding: ({ wrenchTheme }) => ({
      padding: [wrenchTheme.spacing[5], 0, 0, 0],
    }),
    image: ({ isRedirect }: StyleProps) => ({
      objectFit: 'contain',
      maxWidth: ' 100%',
      flexShrink: 0,
      cursor: isRedirect ? 'pointer' : 'default',
    }),
  };
});

export default useStyles;
